import React from 'react'

const labelStyles = {
    fontFamily: 'Jost',
    fontWeight: 600,
    color: 'var(--dark-gray)',
    textTransform: 'capitalize',
}

function Label({children, style}) {
  return (
    <label style={{...labelStyles, ...style}}>{children}</label>
  )
}

export default Label